import React from 'react'
import Modal from "../../components/Modal";

import Opportunity from "../../models/Opportunity";
import {Img} from "react-image";
import {Link} from "react-router-dom";
import OppTeamStatusModalStep from "../talent-opportunities/OppTeamStatusModalStep";
import AdminListView from "./components/AdminListView";
import LoadingSpinner from "../../components/LoadingSpinner";

export default class TalentManagerOppList extends AdminListView
{
    static path = '/manager/opportunities';

    static modelClass() {
        return Opportunity
    };

    static FailedEventName = 'Opportunities@FetchForTalentManagerFailed';
    static SuccessEventName = 'Opportunities@FetchForTalentManagerUpdated';
    static modelName = 'Opportunity';
    static searchPlaceholder = 'Search by team, talent, or project';

    static FetchAllRequest() {
        return Opportunity.FetchAllForTalentManagerRequest
    };

    async fetchResultsForParams(params, refresh) {
        return Opportunity.fetchAllForTalentManager(params, refresh);
    }

    static statusOptions() {
        return Opportunity.statusFlatLookup()
    }

    listDetails(opp)
    {
        let steps = opp.talentSteps();

        let activeStep = TB.find(steps, ['isActive', true]);

        return (
            <tr key={`opp-${opp.id}-team${opp.team?.id}-talent-${opp.talent_user?.id}`}>
                <td>
                    {opp.talentUser()?.fullName()}
                </td>
                <td>
                    {opp.isBYO() && (opp.project_position ? opp.project_position.title : 'N/A')}
                    {opp.isService() && !opp.isForClientEngagementLead() && opp.team && (
                        <div className="flex flex-row items-center">
                            <Link to={opp.team.profilePage()}>{opp.team.name}</Link>
                            {opp.isService() && opp.isAvailable() && (
                                <span onClick={async() => {
                                    await this.promisedState({selectedOpportunity: opp});

                                    await TB.wait(100);

                                    this.modalRef.current.showModal();
                                }} className="ml-2 btn-link-primary clickable">
                                        View Member Status
                                    </span>
                            )}
                        </div>
                    )}
                    {opp.isForClientEngagementLead() && 'Engagement Manager'}
                </td>

                <td>

                    <Img
                        loader={(
                            <div className="self-stretch justify-center items-center flex flex-col">
                                <LoadingSpinner/>
                            </div>
                        )}
                        src={[opp.client?.logo_path || TB.defaultUserProfileImagePath()]}
                        className="img-fluid mr-3"
                        style={{width: 20}}/>

                    {opp.client.name}
                </td>
                <td>
                    {opp.name}
                </td>
                <td>
                    {opp.estimatedFee()}
                </td>

                <td>
                        <span className={`text-${opp.statusClass()}`}>
                            {opp.displayStatus()}
                        </span>
                </td>

                <td>
                        <span>
                            {TB.moment(opp.created_at).format('ll')}
                        </span>
                </td>
                <td>
                    {opp.isAvailable() && activeStep && (
                        <Link
                            to={opp.detailLink()}
                            className="btn btn-outline-dark btn-block">
                            {activeStep.name}
                        </Link>
                    )}
                </td>
            </tr>
        )
    }


    listHeaders() {
		return [
            this.sortedHeader('Talent', 'users'),
            "Team/Project Role",
            this.sortedHeader('Client', 'clients'),
            this.sortedHeader('Project', 'projects'),
            "Est. Payout",
            this.sortedHeader('Status', 'status'),
            this.sortedHeader('Created', 'created_at'),
            "Current Step"
        ]
	}

	renderListFooter() {
        return (
            <Modal ref={this.modalRef}
                   modalClass={"team-status-modal"}
                   onCloseAction={() => {
                       this.setState({selectedOpportunity: null})
                   }}>
                {this.state.selectedOpportunity && (
                    <OppTeamStatusModalStep
                        opportunity={this.state.selectedOpportunity}
                        onClose={async(callback, shouldRefresh = false) => {

                            let selectedOpp = this.state.selectedOpportunity;

                            await this.modalRef.current.hideModal();

                            if (shouldRefresh)
                            {
                                this.setState({isLoading: true})

                                await TB.wait(250);

                                await this.fetchResultsForListView();
                            }

                            if (callback) {
                                await TB.wait(250);
                                await callback();
                            }
                        }}
                    />
                )}
            </Modal>
        )
    }
}